import { createSlice } from '@reduxjs/toolkit';
import { machineApi } from '@custom/rtk-apis/machine/addMachine';

const EditMachineApiSlice = createSlice({
    name: 'EditMachineApiSlice',
    initialState: {
      machinePayload: null,
      status: null,
      loading: false,
      error: null,
      ok: false,
    },
    reducers: {
      reset: (state) => {
        state.machinePayload = null;
        state.loading = false;
        state.error = null;
        state.ok = false;
      },
    },
    extraReducers: (builder) => {
      builder
        .addCase(machineApi.fetchMachineApi.pending, (state) => {
          state.loading = true;
          state.error = null;
          state.ok = false;
        })
        .addCase(machineApi.fetchMachineApi.fulfilled, (state, action) => {
          state.machinePayload = action.payload;
          state.loading = false;
          state.ok = true;
        })
        .addCase(machineApi.fetchMachineApi.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
          state.ok = false;
        });
    },
  });

  export default EditMachineApiSlice.reducer;
  export const { reset } = EditMachineApiSlice.actions
